import { RootState } from "integrations/redux"

const root = (state: RootState) => state.runlevel

export const selectGlobalModal = (state: RootState) => root(state).globalModal
